export default __webpack_public_path__ + "static/media/Google_Play-Logo.12a5e04b.png";